import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

// atoms
import InputField from '../../atoms/InputField'
import TextareaField from '../../atoms/TextareaField'
import TypeCheckboxGroupField from '../../atoms/TypeCheckboxGroupField'

// interfaces
import { IForm } from '../../types/interfaces'

// utils
import { FORM } from '../../utils/enums'

// validate
// eslint-disable-next-line import/no-cycle
import validateCreateTemplateForm from './validations/validateCreateTemplateForm'

export type ComponentProps = {}

type Props = InjectedFormProps<IForm, ComponentProps> &
	ComponentProps & {
		handleSubmit: Function
	}

const CreateTemplateForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit } = props

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit}>
			<Row justify={'center'} className={'mt-2 w-full'}>
				<Col span={24}>
					<Field
						component={InputField}
						label={t('loc:Template name')}
						placeholder={t('loc:Enter template name')}
						name={'name'}
						size={'large'}
						required
					/>
				</Col>
				<Col span={24}>
					<Field component={TypeCheckboxGroupField} label={t('loc:Template type')} name={'type'} size={'large'} required />
				</Col>
				<Col span={24}>
					<Field
						component={TextareaField}
						label={t('loc:Description')}
						placeholder={t('loc:Enter description')}
						name={'description'}
						size={'large'}
						minHeight={80}
					/>
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IForm, ComponentProps>({
	form: FORM.FORM_TEMPLATE,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	validate: validateCreateTemplateForm
})(CreateTemplateForm)

export default form
